//Liability actions

//Get liability List
import {
  GET_LIABILITY_LIST,
  GET_LIABILITY_LIST_SUCCESS,
  GET_LIABILITY_LIST_FAILURE,
  GET_LIABILITY_DETAIL,
  GET_LIABILITY_DETAIL_SUCCESS,
  GET_LIABILITY_DETAIL_FAILURE,
  CREATE_LIABILITY,
  CREATE_LIABILITY_SUCCESS,
  CREATE_LIABILITY_FAILURE,
  UPDATE_LIABILITY,
  UPDATE_LIABILITY_SUCCESS,
  UPDATE_LIABILITY_FAILURE,
  DELETE_LIABILITY,
  DELETE_LIABILITY_SUCCESS,
  DELETE_LIABILITY_FAILURE,
  GET_LIABILITY_PROVIDER_LIST,
  GET_LIABILITY_PROVIDER_LIST_SUCCESS,
  GET_LIABILITY_PROVIDER_LIST_FAILURE,
  GET_LIABILITY_PROVIDER_DETAIL,
  GET_LIABILITY_PROVIDER_DETAIL_SUCCESS,
  GET_LIABILITY_PROVIDER_DETAIL_FAILURE,
  CREATE_LIABILITY_PROVIDER,
  CREATE_LIABILITY_PROVIDER_SUCCESS,
  CREATE_LIABILITY_PROVIDER_FAILURE,
  UPDATE_LIABILITY_PROVIDER,
  UPDATE_LIABILITY_PROVIDER_SUCCESS,
  UPDATE_LIABILITY_PROVIDER_FAILURE,
  DELETE_LIABILITY_PROVIDER,
  DELETE_LIABILITY_PROVIDER_SUCCESS,
  DELETE_LIABILITY_PROVIDER_FAILURE,
  GET_LIABILITY_STATUS_LIST,
  GET_LIABILITY_STATUS_LIST_SUCCESS,
  GET_LIABILITY_STATUS_LIST_FAILURE,
  GET_LIABILITY_STATUS_DETAIL,
  GET_LIABILITY_STATUS_DETAIL_SUCCESS,
  GET_LIABILITY_STATUS_DETAIL_FAILURE,
  CREATE_LIABILITY_STATUS,
  CREATE_LIABILITY_STATUS_SUCCESS,
  CREATE_LIABILITY_STATUS_FAILURE,
  UPDATE_LIABILITY_STATUS,
  UPDATE_LIABILITY_STATUS_SUCCESS,
  UPDATE_LIABILITY_STATUS_FAILURE,
  DELETE_LIABILITY_STATUS,
  DELETE_LIABILITY_STATUS_SUCCESS,
  DELETE_LIABILITY_STATUS_FAILURE,
  GET_LIABILITY_ITEM_CATEGORY_LIST,
  GET_LIABILITY_ITEM_CATEGORY_LIST_SUCCESS,
  GET_LIABILITY_ITEM_CATEGORY_LIST_FAILURE,
  GET_LIABILITY_ITEM_CATEGORY_DETAIL,
  GET_LIABILITY_ITEM_CATEGORY_DETAIL_SUCCESS,
  GET_LIABILITY_ITEM_CATEGORY_DETAIL_FAILURE,
  CREATE_LIABILITY_ITEM_CATEGORY,
  CREATE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  CREATE_LIABILITY_ITEM_CATEGORY_FAILURE,
  UPDATE_LIABILITY_ITEM_CATEGORY,
  UPDATE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  UPDATE_LIABILITY_ITEM_CATEGORY_FAILURE,
  DELETE_LIABILITY_ITEM_CATEGORY,
  DELETE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  DELETE_LIABILITY_ITEM_CATEGORY_FAILURE,
} from "./actionType";

export const getLiabilityList = () => ({
  type: GET_LIABILITY_LIST,
});

export const getLiabilityListSuccess = (response) => ({
  type: GET_LIABILITY_LIST_SUCCESS,
  payload: response,
});

export const getLiabilityListFailure = (error) => ({
  type: GET_LIABILITY_LIST_FAILURE,
  payload: error,
});

//Get liability Detail
export const getLiabilityDetail = (id) => ({
  type: GET_LIABILITY_DETAIL,
  payload: id,
});

export const getLiabilityDetailSuccess = (response) => ({
  type: GET_LIABILITY_DETAIL_SUCCESS,
  payload: response,
});

export const getLiabilityDetailFailure = (error) => ({
  type: GET_LIABILITY_DETAIL_FAILURE,
  payload: error,
});

//Create liability
export const createLiability = (data) => ({
  type: CREATE_LIABILITY,
  payload: data,
});

export const createLiabilitySuccess = (response) => ({
  type: CREATE_LIABILITY_SUCCESS,
  payload: response,
});

export const createLiabilityFailure = (error) => ({
  type: CREATE_LIABILITY_FAILURE,
  payload: error,
});

//Update liability
export const updateLiability = (data) => ({
  type: UPDATE_LIABILITY,
  payload: data,
});

export const updateLiabilitySuccess = (response) => ({
  type: UPDATE_LIABILITY_SUCCESS,
  payload: response,
});

export const updateLiabilityFailure = (error) => ({
  type: UPDATE_LIABILITY_FAILURE,
  payload: error,
});

//Delete liability
export const deleteLiability = (id) => ({
  type: DELETE_LIABILITY,
  payload: id,
});

export const deleteLiabilitySuccess = (response) => ({
  type: DELETE_LIABILITY_SUCCESS,
  payload: response,
});

export const deleteLiabilityFailure = (error) => ({
  type: DELETE_LIABILITY_FAILURE,
  payload: error,
});

// Get Liability Provider List
export const getLiabilityProviderList = () => ({
  type: GET_LIABILITY_PROVIDER_LIST,
});

export const getLiabilityProviderListSuccess = (response) => ({
  type: GET_LIABILITY_PROVIDER_LIST_SUCCESS,
  payload: response,
});

export const getLiabilityProviderListFailure = (error) => ({
  type: GET_LIABILITY_PROVIDER_LIST_FAILURE,
  payload: error,
});

// Get Liability Provider Detail
export const getLiabilityProviderDetail = (id) => ({
  type: GET_LIABILITY_PROVIDER_DETAIL,
  payload: id,
});

export const getLiabilityProviderDetailSuccess = (response) => ({
  type: GET_LIABILITY_PROVIDER_DETAIL_SUCCESS,
  payload: response,
});

export const getLiabilityProviderDetailFailure = (error) => ({
  type: GET_LIABILITY_PROVIDER_DETAIL_FAILURE,
  payload: error,
});

// Create Liability Provider
export const createLiabilityProvider = (data) => ({
  type: CREATE_LIABILITY_PROVIDER,
  payload: data,
});

export const createLiabilityProviderSuccess = (response) => ({
  type: CREATE_LIABILITY_PROVIDER_SUCCESS,
  payload: response,
});

export const createLiabilityProviderFailure = (error) => ({
  type: CREATE_LIABILITY_PROVIDER_FAILURE,
  payload: error,
});

// Update Liability Provider
export const updateLiabilityProvider = (data) => ({
  type: UPDATE_LIABILITY_PROVIDER,
  payload: data,
});

export const updateLiabilityProviderSuccess = (response) => ({
  type: UPDATE_LIABILITY_PROVIDER_SUCCESS,
  payload: response,
});

export const updateLiabilityProviderFailure = (error) => ({
  type: UPDATE_LIABILITY_PROVIDER_FAILURE,
  payload: error,
});

// Delete Liability Provider
export const deleteLiabilityProvider = (id) => ({
  type: DELETE_LIABILITY_PROVIDER,
  payload: id,
});

export const deleteLiabilityProviderSuccess = (response) => ({
  type: DELETE_LIABILITY_PROVIDER_SUCCESS,
  payload: response,
});

export const deleteLiabilityProviderFailure = (error) => ({
  type: DELETE_LIABILITY_PROVIDER_FAILURE,
  payload: error,
});

// Get Liability Status List
export const getLiabilityStatusList = () => ({
  type: GET_LIABILITY_STATUS_LIST,
});

export const getLiabilityStatusListSuccess = (response) => ({
  type: GET_LIABILITY_STATUS_LIST_SUCCESS,
  payload: response,
});

export const getLiabilityStatusListFailure = (error) => ({
  type: GET_LIABILITY_STATUS_LIST_FAILURE,
  payload: error,
});

// Get Liability Status Detail
export const getLiabilityStatusDetail = (id) => ({
  type: GET_LIABILITY_STATUS_DETAIL,
  payload: id,
});

export const getLiabilityStatusDetailSuccess = (response) => ({
  type: GET_LIABILITY_STATUS_DETAIL_SUCCESS,
  payload: response,
});

export const getLiabilityStatusDetailFailure = (error) => ({
  type: GET_LIABILITY_STATUS_DETAIL_FAILURE,
  payload: error,
});

// Create Liability Status
export const createLiabilityStatus = (data) => ({
  type: CREATE_LIABILITY_STATUS,
  payload: data,
});

export const createLiabilityStatusSuccess = (response) => ({
  type: CREATE_LIABILITY_STATUS_SUCCESS,
  payload: response,
});

export const createLiabilityStatusFailure = (error) => ({
  type: CREATE_LIABILITY_STATUS_FAILURE,
  payload: error,
});

// Update Liability Status
export const updateLiabilityStatus = (data) => ({
  type: UPDATE_LIABILITY_STATUS,
  payload: data,
});

export const updateLiabilityStatusSuccess = (response) => ({
  type: UPDATE_LIABILITY_STATUS_SUCCESS,
  payload: response,
});

export const updateLiabilityStatusFailure = (error) => ({
  type: UPDATE_LIABILITY_STATUS_FAILURE,
  payload: error,
});

// Delete Liability Status
export const deleteLiabilityStatus = (id) => ({
  type: DELETE_LIABILITY_STATUS,
  payload: id,
});

export const deleteLiabilityStatusSuccess = (response) => ({
  type: DELETE_LIABILITY_STATUS_SUCCESS,
  payload: response,
});

export const deleteLiabilityStatusFailure = (error) => ({
  type: DELETE_LIABILITY_STATUS_FAILURE,
  payload: error,
});

// Get Liability Item Category List
export const getLiabilityItemCategoryList = () => ({
  type: GET_LIABILITY_ITEM_CATEGORY_LIST,
});

export const getLiabilityItemCategoryListSuccess = (response) => ({
  type: GET_LIABILITY_ITEM_CATEGORY_LIST_SUCCESS,
  payload: response,
});

export const getLiabilityItemCategoryListFailure = (error) => ({
  type: GET_LIABILITY_ITEM_CATEGORY_LIST_FAILURE,
  payload: error,
});

// Get Liability Item Category Detail
export const getLiabilityItemCategoryDetail = (id) => ({
  type: GET_LIABILITY_ITEM_CATEGORY_DETAIL,
  payload: id,
});

export const getLiabilityItemCategoryDetailSuccess = (response) => ({
  type: GET_LIABILITY_ITEM_CATEGORY_DETAIL_SUCCESS,
  payload: response,
});

export const getLiabilityItemCategoryDetailFailure = (error) => ({
  type: GET_LIABILITY_ITEM_CATEGORY_DETAIL_FAILURE,
  payload: error,
});

// Create Liability Item Category
export const createLiabilityItemCategory = (data) => ({
  type: CREATE_LIABILITY_ITEM_CATEGORY,
  payload: data,
});

export const createLiabilityItemCategorySuccess = (response) => ({
  type: CREATE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  payload: response,
});

export const createLiabilityItemCategoryFailure = (error) => ({
  type: CREATE_LIABILITY_ITEM_CATEGORY_FAILURE,
  payload: error,
});

// Update Liability Item Category
export const updateLiabilityItemCategory = (data) => ({
  type: UPDATE_LIABILITY_ITEM_CATEGORY,
  payload: data,
});

export const updateLiabilityItemCategorySuccess = (response) => ({
  type: UPDATE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  payload: response,
});

export const updateLiabilityItemCategoryFailure = (error) => ({
  type: UPDATE_LIABILITY_ITEM_CATEGORY_FAILURE,
  payload: error,
});

// Delete Liability Item Category
export const deleteLiabilityItemCategory = (id) => ({
  type: DELETE_LIABILITY_ITEM_CATEGORY,
  payload: id,
});

export const deleteLiabilityItemCategorySuccess = (response) => ({
  type: DELETE_LIABILITY_ITEM_CATEGORY_SUCCESS,
  payload: response,
});

export const deleteLiabilityItemCategoryFailure = (error) => ({
  type: DELETE_LIABILITY_ITEM_CATEGORY_FAILURE,
  payload: error,
});
